import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, concatMap } from 'rxjs/operators';
import { Action } from 'redux';
import { UpdateRecordLabelName, UpdateRecordLabel } from '../action-creators';
import { UPDATE_RECORD_LABEL_NAME } from '../actions';
import AppState from '../../state';
import { NoOp } from '@webapp/store/ui/action-creators';
import { keyDebounceTime } from '../../operators';


export const autosaveEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, UpdateRecordLabelName>(UPDATE_RECORD_LABEL_NAME),
    keyDebounceTime(2000, (action) => action.recordLabelId),
    withLatestFrom(state$),
    concatMap(([actions, state]) => {
      return actions.map((action) => {

        const recordLabel = state.recordLabels.list.find((r) => r.id === action.recordLabelId);

        if (!recordLabel) {
          return new NoOp();
        }

        return new UpdateRecordLabel(recordLabel)
      })
    })
  );